var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.showLoading
    ? _c("div", { staticClass: "global-loading-overlay" }, [
        _c(
          "div",
          { staticClass: "global-loading-overlay__loading sticky-top" },
          [
            _c("img", {
              staticClass: "loading__icon",
              attrs: {
                src: require("./assets/icon-loading-spinner--dark.svg"),
              },
            }),
            _c(
              "span",
              { staticClass: "loading__label" },
              [_vm._t("default")],
              2
            ),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }